import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import AppLayout from "./layouts/AppLayout";
import Home from "./pages/Home";
import VerifyCertificate from "./pages/VerifyCertificate";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AddCertificate from "./pages/AddCertificate";
import EditCertificate from "./pages/EditCertificate";
import PageMeta from "./components/PageMeta";

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<AppLayout />}>
          <Route
            path="/"
            element={
              <>
                <PageMeta title="SmartGoNext | Internship Verification Portal" description="Official portal to verify SmartGoNext internship certificates. Enter a certificate ID to view student and internship details." />
                <Home />
              </>
            }
          />

          <Route
            path="/verify"
            element={
              <>
                <PageMeta title="Verify Certificate | SmartGoNext" description="Enter a certificate ID to verify its authenticity and view the details." />
                <VerifyCertificate />
              </>
            }
          />

          <Route
            path="/admin/login"
            element={
              <>
                <PageMeta title="Admin Login | SmartGoNext" description="Admin login for SmartGoNext Internship Verification Portal" />
                <AdminLogin />
              </>
            }
          />

          <Route
            path="/admin/dashboard"
            element={
              <>
                <PageMeta title="Admin Dashboard | SmartGoNext" description="Manage certificates and verify issuance on SmartGoNext." />
                <AdminDashboard />
              </>
            }
          />

          <Route
            path="/admin/add"
            element={
              <>
                <PageMeta title="Add Certificate | SmartGoNext" description="Issue a new internship certificate on SmartGoNext." />
                <AddCertificate />
              </>
            }
          />

          <Route
            path="/admin/edit/:certId"
            element={
              <>
                <PageMeta title="Edit Certificate | SmartGoNext" description="Update student and internship details for a certificate." />
                <EditCertificate />
              </>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
